<template>
  <v-card>
    <v-container>
      <v-layout wrap>
        <v-flex sm12>
          <p class="title">{{ dataOption.optionName }}</p>
        </v-flex>
        <v-flex sm11>
          <v-form @submit="createName" ref="form">
            <v-text-field
              v-model="personalDataName"
              solo
              :label="'Agregar nueva opción para ' + dataOption.optionName"
              :rules="requiredRule"
              background-color="grey lighten-3"
            ></v-text-field>
          </v-form>
        </v-flex>
        <v-flex sm1 pt-2 pl-2>
          <v-btn text icon color="grey" @click="createName">
            <v-icon large>mdi-plus</v-icon>
          </v-btn>
        </v-flex>

        <!-- Name -->

        <v-flex>
          <OptionName
            v-for="(option, index) in dataOption.options"
            :key="index"
            :option="option"
            @updateOptions="updateOp"
          ></OptionName>
        </v-flex>
      </v-layout>
    </v-container>

    <v-snackbar v-model="snackbar" top right>
      {{ message }}
      <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import OptionName from "@/components/OptionName";
import axios from "axios";
export default {
  name: "DataOptionsCard",
  props: {
    dataOption: Object
  },
  components: {
    OptionName
  },
  data() {
    return {
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      personalDataName: "",
      snackbar: false,
      message: "",
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    createName() {
      if (this.$refs.form.validate()) {
        let data = {
          optionName: this.personalDataName,
          idPersonalDataOptions: this.dataOption.idPersonalDataOptions,
          idUser: this.$route.params.idUser,
          idUserVerify: sessionStorage.getItem("authorization")
        };

        axios
          .post(
            this.host + "/personaldataoptions/optionname/create.php",
            this.createFormData(data)
          )
          .then(response => {
            this.personalDataName = "";
            this.message = response.data.message;
            this.snackbar = true;
            this.$emit("updateOptions");
            this.$refs.form.resetValidation();
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    updateOp() {
      this.$emit("updateOptions");
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  }
};
</script>